import RestorePasswordForm from "./RestorePasswordForm";

export default RestorePasswordForm;
